import APIV5 from '~/models/api';
import { UserModel } from '~/scripts/services/model/user';

// TODO: ce controlleur devrait être associé a un service
// Le service devrait contenir la gestion de la langue et non ce controlleur
// Afin de pouvoir accéder au fonctions de changement de langue depuis n'importe où

/* globals Knitiv */

export default class LangController {
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 * @param {UserModel} User
	 */
	/* @ngInject */
	constructor(
		$rootScope,
		$timeout,
		$translate,
		Notification,
		User,
	) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.Notification = Notification;
		this.User = User;

		this.loading = false;

		/**
		 * @type {any[]}
		 */
		this.langs = [];

		this.watching = true;

		this.$rootScope.$watch(
			'appConfig.lang',
			/**
			 *
			 * @param {import('@knitiv/api-client-javascript').GetConfigOutput['lang']} lang
			 * @param {import('@knitiv/api-client-javascript').GetConfigOutput['lang']} oldLang
			 */
			async (lang, oldLang) => {
				if (
					this.watching
					&& !this.loading
					&& (
						(lang && oldLang && lang.code && lang.code !== oldLang.code)
						|| this.langs?.length === 0
					)
				) {
					this.loading = true;
					await this.setLanguage(lang.code, lang.kid);
					const uiContent = await APIV5.instance.uiGetContent(
						{ path: 'LANG' },
						{ id: 'lang' },
					);
					this.$timeout(() => {
						this.langs = uiContent.result;
						this.loading = false;
					});
				}
			});
	}

	/**
	 * @param {string} code
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	async changeLanguage(code, kid) {
		// internal
		await this.setLanguage(code, kid);
		// api
		await APIV5.instance.langSet({ lang_kid: kid }, { id: 'lang.change-language' });
		this.$rootScope.$broadcast('changeLanguage', { id: code, kid });
	}

	/**
	 * @param {string|any} code
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {Promise<any>} Context lang
	 */
	async setLanguage(code, kid) {
		this.watching = false;

		try {
			/** @type {string} */
			const id = await this.$translate.use(code);
			if (id) {
				this.User.setLang({
					code: id,
					kid,
				});
			}
		}
		catch (error) {
			console.error('error', error);
			this.Notification.error({
				title:   'Error',
				message: `Unknown language ${error}, revert to language FR.`,
			});
			const lang = await this.$translate.use('fr') || 'fr';
			this.User.setLang({
				code: lang,
				kid: 'K_NODE;FRANCAIS',
				// name: this.$translate.instant(`lang.${lang}`),
			});
		}
		this.$timeout(() => {
			this.watching = true;
		});

		// @ts-ignore
		return this.$rootScope.appConfig.lang;
	}
}
